<template>
  <div class="full-container">
    <div
        style="width: 100%;float: left;height: 50px;line-height: 50px;font-size: 0.9rem; text-align: left;opacity: 0.9;">
      专家库
    </div>
    <div style="width:100%;height:auto;float:left;border-radius: 15px;background-color: white;padding-bottom:40px;">

      <div style="width:100%;float:left;margin-top: 10px;">
        <!-- 查询按钮区 -->
        <div style="width: 100%;height: 60px;float: left;line-height: 60px;padding-left: 15px">
          <!-- 右边按钮 -->
          <div style="width: auto;float: right;margin-right: 20px">
            <el-button size="mini" style="background-color: #25AD7F;border:none;" type="primary" @click="insertShow()">
              <a-icon type="plus-circle"/>
              新增专家
            </el-button>
          </div>
        </div>

        <!-- 表单内容 -->
        <div style="width:100%;float:left;padding: 15px;">
          <div v-for="item in expertList" v-if="expertList&&expertList.length>0"
               style="width: 30%;margin-left: 2.5%;float: left;margin-bottom: 30px;">
            <el-card class="box-card" style="width: 100%;float: left;">
              <!-- 标题 -->
              <div v-if="item" slot="header" class="clearfix">
                <div style="float:left;width: 40%;text-align: left;">
                  {{ item.name }}
                </div>
                <div style="float:left;width: 60%;text-align: right;">
                  <a-popconfirm cancel-text="取消" ok-text="确定" title="是否删除?(敏感操作!)"
                                @confirm="deleteExpert(item)">
                    <el-button style="float: right; padding: 3px 0;margin-left:10px;color:#e32e2e;" type="text">删除
                    </el-button>
                  </a-popconfirm>

                  <el-button style="float: right; padding: 3px 0;color:#409EFF;" type="text" @click="updateShow(item)">
                    修改
                  </el-button>
                  <el-button style="float: right; padding: 3px 0;color:#25AD7F" type="text" @click="detailShow(item)">
                    详情
                  </el-button>
                </div>
              </div>
              <!-- 内容 -->
              <div style="width: 100%;float: left;border-bottom:1px solid #EBEEF5">
                <!-- 照片 -->
                <div style="width: 100px;float: left;text-align: left;">
                  <el-image v-if="item.mainImageGuid" :preview-src-list="['/admin/web/file/downloadFile?id='+item.mainImageGuid]"
                            :src="'/admin/web/file/downloadFile?id='+item.mainImageGuid"
                            style="width: 100px; height: 100px"
                            title="点击放大">
                  </el-image>
                </div>
                <!-- 文本 -->
                <div style="width: calc(100% - 100px);float: left;text-align: left;padding-left:10px;">
                  <div style="width: 100%;float: left;font-size:0.8rem;margin-bottom: 15px">
                    <div style="width: 20%;float: left;opacity: 0.8;">
                      从业年限：
                    </div>
                    <div class="text-ellipsis" style="width: 80%;float: left;fonts-size:0.8rem;word-wrap: break-word">
                      {{ item.year ? item.year : "0" }}年
                    </div>
                  </div>
                  <div style="width: 100%;float: left;font-size:0.8rem;margin-bottom: 15px">
                    <div style="width: 20%;float: left;opacity: 0.8;">
                      职称：
                    </div>
                    <div class="text-ellipsis" style="width: 80%;float: left;fonts-size:0.8rem;word-wrap: break-word">
                      {{ item.level ? item.level : "0" }}
                    </div>
                  </div>
                  <div style="width: 100%;float: left;font-size:0.8rem;margin-bottom: 15px">
                    <div style="width: 20%;float: left;opacity: 0.8;">
                      擅长领域：
                    </div>
                    <div class="text-ellipsis" style="width: 80%;float: left;fonts-size:0.8rem;word-wrap: break-word">
                      {{ item.skill ? item.skill : "0" }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- 底部按钮 -->
              <div style="width: 100%;float: left;padding-top: 18px;">
                <el-button style="float: right; padding: 3px 0;margin-left: 10px;color:#25AD7F"
                           type="text" @click="ExpertMessageShow(item)">留言咨询
                </el-button>
              </div>
            </el-card>
          </div>
        </div>
        <div v-show="!(expertList&&expertList.length>0)" style="width: 100%;float:left;">
          <el-empty description="还没有添加专家">
            <el-button style="background-color: #25AD7F;border:none;" type="primary" @click="insertShow()">
              添加专家
            </el-button>
          </el-empty>
        </div>
      </div>
    </div>

    <el-dialog :before-close="insertCancel" :visible.sync="insertDialog" title="新增专家" width="40%">
      <div style="width: 100%;float: left">
        <el-form label-width="15%" style="width:100%;float:left;">
          <el-form-item style="">
            <template slot="label">
              专家名称 <span style="color: red">*</span>
            </template>
            <el-input v-model="insertForm.name" oninput="if(value.length>35)value=value.slice(0,35)" size="mini"
                      style="width:85%;float: left;"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>

          <el-form-item style="">
            <template slot="label">
              工作人员
            </template>
            <el-select v-model="insertForm.userId" clearable filterable size="mini" style="float: left;">
              <el-option v-for="item in merchantUserList" :key="item.id" :label="item.name + '-'+item.no"
                         :value="item.id">
              </el-option>
            </el-select>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>


          <el-form-item>
            <template slot="label">
              从业年限 <span style="color: red">*</span>
            </template>
            <el-input v-model="insertForm.year" class="numberInput" oninput="if(value.length>10)value=value.slice(0,10)" size="mini"
                      style="width:85%;float: left;"
                      type="number"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>

          <el-form-item label="">
            <template slot="label">
              职称
            </template>
            <el-input v-model="insertForm.level" oninput="if(value.length>35)value=value.slice(0,35)" size="mini"
                      style="width:85%;float: left;"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>

          <el-form-item label="">
            <template slot="label">
              擅长领域
            </template>
            <el-input v-model="insertForm.skill" oninput="if(value.length>250)value=value.slice(0,250)" size="mini"
                      style="width:85%;float: left;"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>


          <el-form-item label="">
            <template slot="label">
              头像 <span style="color: red">*</span>
            </template>
            <el-upload :auto-upload="false" :multiple="false" :on-change="changeCompanyIdCard"
                       :show-file-list="false" action="#" list-type="picture-card">
              <el-image v-if="mainImageFile" :src="mainImageFile.url" class="avatar" fit="contain"/>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>
          <el-form-item label="">
            <template slot="label">
              二维码
            </template>
            <el-upload :auto-upload="false" :multiple="false" :on-change="changeQrcodeCompanyIdCard"
                       :show-file-list="false" action="#" list-type="picture-card">
              <el-image v-if="qrcodeImageFile" :src="qrcodeImageFile.url" class="avatar" fit="contain"/>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>

          <el-form-item label="">
            <template slot="label">
              详细图片<span style="color: red">*</span>
            </template>
            <el-upload :auto-upload="false" :file-list="detailImageFileList" :limit=9 :multiple="true" :on-change="changeChargeUserIdCard"
                       action="#" list-type="picture-card">
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}">
                <img :src="file.url" alt="" class="el-upload-list__item-thumbnail">
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="detailImageShowDialog(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span class="el-upload-list__item-delete" @click="removeChargeUserIdCard(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
            <!-- 大图显示 -->
            <el-dialog :visible.sync="detailImageShow">
              <img :src="detailImageShowUrl" alt="" width="100%">
            </el-dialog>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>
        </el-form>

      </div>
      <div class="dialog-footer">
        <el-button class="dialog-footer-submit" @click="insertSubmit">提交</el-button>
        <el-button class="dialog-footer-cancel" @click="insertCancel">取消</el-button>
      </div>
    </el-dialog>

    <!-- 详情 -->
    <el-dialog :before-close="detailCancel" :visible.sync="detailDialog" title="专家详情" width="40%">
      <div style="width: 100%;float: left">
        <div
            v-if="detailInfo"
            style="width: 100%;float: left;border-bottom: 1px solid #80808054;padding-bottom: 15px;margin-bottom: 20px;">

          <el-descriptions :column=2 title="商户">
            <el-descriptions-item label="商户名称"> {{detailInfo.merchantVO && detailInfo.merchantVO.merchantDetailVO ? detailInfo.merchantVO.merchantDetailVO.companyName : ''}}
            </el-descriptions-item>

          </el-descriptions>

          <el-descriptions :column=2 :title="detailInfo.name?detailInfo.name:''">
            <el-descriptions-item label="从业年限">{{ detailInfo.year ? detailInfo.year : "" }}
            </el-descriptions-item>
            <el-descriptions-item label="资历头衔">{{ detailInfo.level ? detailInfo.level : "" }}
            </el-descriptions-item>
            <el-descriptions-item label="擅长技能">{{ detailInfo.skill ? detailInfo.skill : "" }}
            </el-descriptions-item>
            <el-descriptions-item :span="2" label="创建时间">
              {{
                parseDate(detailInfo.createDate ? detailInfo.createDate : "")
              }}
            </el-descriptions-item>



            <el-descriptions-item :span="2" label="缩略照片">
              <el-image v-if="detailInfo.mainImageGuid"
                        :preview-src-list="['/admin/web/file/downloadFile?id='+detailInfo.mainImageGuid]"
                        :src="'/admin/web/file/downloadFile?id='+detailInfo.mainImageGuid"
                        style="width: 100px; height: 100px"
                        title="点击放大">
              </el-image>
            </el-descriptions-item>
            <el-descriptions-item :span="2" label="详细照片">
              <div v-for="guid in detailInfo.detailImageGuid" v-if="detailInfo.detailImageGuid"
                   style="width: 100%;float: left;">
                <el-image :preview-src-list="['/admin/web/file/downloadFile?id='+guid]"
                          :src="'/admin/web/file/downloadFile?id='+guid"
                          style="width: 100px; height: auto"
                          title="点击放大">
                </el-image>
                <br/>
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </div>

      </div>
      <div class="dialog-footer">
        <el-button class="dialog-footer-cancel" @click="detailCancel">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 修改 -->
    <el-dialog :before-close="updateCancel" :visible.sync="updateDialog" title="修改专家" width="40%">
      <div style="width: 100%;float: left">
        <el-form label-width="15%" style="width:100%;float:left;">
          <el-form-item style="">
            <template slot="label">
              专家名称 <span style="color: red">*</span>
            </template>
            <el-input v-model="updateForm.name" oninput="if(value.length>35)value=value.slice(0,35)" size="mini"
                      style="width:85%;float: left;"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>

          <el-form-item style="">
            <template slot="label">
              工作人员
            </template>
            <el-select v-model="updateForm.userId" clearable filterable size="mini" style="float: left;">
              <el-option v-for="item in merchantUserList" :key="item.id" :label="item.name + '-'+item.no"
                         :value="item.id">
              </el-option>
            </el-select>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>


          <el-form-item>
            <template slot="label">
              从业年限 <span style="color: red">*</span>
            </template>
            <el-input v-model="updateForm.year" class="numberInput" oninput="if(value.length>10)value=value.slice(0,10)" size="mini"
                      style="width:85%;float: left;"
                      type="number"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>

          <el-form-item label="">
            <template slot="label">
              职称
            </template>
            <el-input v-model="updateForm.level" oninput="if(value.length>35)value=value.slice(0,35)" size="mini"
                      style="width:85%;float: left;"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>

          <el-form-item label="">
            <template slot="label">
              擅长领域
            </template>
            <el-input v-model="updateForm.skill" oninput="if(value.length>250)value=value.slice(0,250)" size="mini"
                      style="width:85%;float: left;"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>


          <el-form-item label="">
            <template slot="label">
              头像 <span style="color: red">*</span>
            </template>
            <el-upload :auto-upload="false" :multiple="false" :on-change="updateChangeCompanyIdCard"
                       :show-file-list="false" action="#" list-type="picture-card">
              <el-image v-if="updateMainImageFileUrl" ref="mainref" :src="updateMainImageFileUrl" class="avatar"
                        fit="contain"/>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>
          <el-form-item label="">
            <template slot="label">
              二维码
            </template>
            <el-upload :auto-upload="false" :multiple="false" :on-change="updateChangeQrcodeCompanyIdCard"
                       :show-file-list="false" action="#" list-type="picture-card">
              <el-image v-if="updateQrcodeImageFileUrl" ref="mainref" :src="updateQrcodeImageFileUrl" class="avatar"
                        fit="contain"/>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>
          <el-form-item label="">
            <template slot="label">
              详细图片<span style="color: red">*</span>
            </template>
            <el-upload :auto-upload="false" :file-list="updateDetailImageFileListUrl" :limit=9 :multiple="true"
                       :on-change="updateChangeChargeUserIdCard"
                       action="#" list-type="picture-card">
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}">
                <img :src="file.url" alt="" class="el-upload-list__item-thumbnail">
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="updateDetailImageShowDialog(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span class="el-upload-list__item-delete" @click="updateRemoveChargeUserIdCard(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
            <!-- 大图显示 -->
            <el-dialog :visible.sync="updateDetailImageShow">
              <img :src="updateDetailImageShowUrl" alt="" width="100%">
            </el-dialog>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>
        </el-form>

      </div>
      <div class="dialog-footer">
        <el-button class="dialog-footer-submit" @click="updateSubmit">提交</el-button>
        <el-button class="dialog-footer-cancel" @click="updateCancel">取消</el-button>
      </div>
    </el-dialog>

    <!-- 留言咨询 -->
    <el-drawer title="留言咨询"
               :visible.sync="expertMessageDialog" direction="rtl">

      <div v-if="expertMessageList!=null&&expertMessageList.length>0" style="width: 100%;float: left;">
        <div style="width: 100%;float: left;border:1px solid #D8D8D8;padding: 16px 0px;" v-for="item in expertMessageList">

          <div style="width: 15%;float: left;padding: 8px" >
            <el-image v-if="item.userVO&&item.userVO.userLogoGuid" :preview-src-list="['/admin/web/file/downloadFile?id='+item.userVO.userLogoGuid]"
                      :src="'/admin/web/file/downloadFile?id='+item.userVO.userLogoGuid"
                      style="width: 100%; height: auto"
                      title="点击放大">
            </el-image>
            <el-image v-else
                      :src="require('@/assets/user-logo.png')"
                      style="width: 100%; height: auto"
                      title="点击放大">
            </el-image>
          </div>
          <div style="width: 85%;float: left;text-align: left;">
            <div style="margin-bottom: 8px;">
              {{item.userVO?item.userVO.name:""}}
            </div>
            <div  style="margin-bottom: 8px;font-size: 0.7rem;color: gray;">
              {{item.createDateStr?item.createDateStr:""}}
            </div>
            <div  style="margin-bottom: 8px;font-size: 0.85rem;">
              {{item.context?item.context:""}}
            </div>

          </div>
          <div  v-for="guid in item.expertMessageImageListGuid"
                v-if="item.expertMessageImageListGuid&&item.expertMessageImageListGuid.length>0"
                style="width:100%;float: left;padding: 20px;margin-bottom: 20px;text-align: left;">
            <el-image v-if="guid" :preview-src-list="['/admin/web/file/downloadFile?id='+guid]"
                      :src="'/admin/web/file/downloadFile?id='+guid"
                      style="width: auto; height: 50px"
                      title="点击放大">
            </el-image>

          </div>
        </div>
      </div>
      <el-empty v-else description="暂无留言咨询"></el-empty>

    </el-drawer>


  </div>
</template>

<script>

import {deleteExpertApi, listMerchantExpertApi} from "@/router/api/expert/expert-api";
import {getMyMerchantUserApi} from "@/router/api/merchant/merchant-api";
import {listAllExpertMessageApi} from "@/router/api/expert/expert-message-api";

export default {
  name: "MerchantExpert",
  data() {
    return {

      merchantUserList: [],

      expertList: [],

      //新增
      insertDialog: false,
      insertForm: {
        userId: null,
        name: null,
        year: null,
        level: null,
        skill: null,
        context: null
      },
      mainImageFile: null,
      qrcodeImageFile: null,
      detailImageFileList: [],
      detailImageShow: false,//是否显示大图
      detailImageShowUrl: "",//大图的url

      //  详情
      detailDialog: false,
      detailInfo: null,

      //留言咨询
      expertMessageDialog: false,
      expertMessageList:null,

      //修改
      updateDialog: false,
      updateForm: {
        id: null,
        name: null,
        userId: null,
        year: null,
        level: null,
        skill: null,
        context: null
      },


      updateMainImageFile: null,
      updateMainImageFileUrl: null,

      updateQrcodeImageFile: null,
      updateQrcodeImageFileUrl: null,

      updateDetailImageFileListUrl: [],
      updateDetailImageShow: false,//是否显示大图
      updateDetailImageShowUrl: ""//大图的url


    };
  },

  mounted() {

    this.load();


  },

  methods: {

    load() {
      this.listMerchantExpert();


      getMyMerchantUserApi({}, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.merchantUserList = res.data.resultSetData;
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });

    },


    // 查询 begin
    listMerchantExpert(showMessage) {
      listMerchantExpertApi({}, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              if (showMessage) {
                this.showMessage(res.data.msg, "success");
              }
              this.expertList = res.data.resultSetData;
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },
    // 查询 end


    // 新增 begin

    insertShow() {
      this.insertDialog = true;
    },

    insertCancel() {
      this.insertDialog = false;
      this.insertForm = {
        userId: null,
        name: null,
        year: null,
        level: null,
        skill: null,
        context: null
      };
      this.mainImageFile = null;
      this.qrcodeImageFile = null;
      this.detailImageFileList = [];
      this.detailImageShow = false;
      this.detailImageShowUrl = "";
    },


    // 营业执照上传
    changeCompanyIdCard(file) {

      let thizz = this;
      thizz.mainImageFile = file;
    },

    changeQrcodeCompanyIdCard(file) {
      this.qrcodeImageFile = file;
    },

    //身份证上传
    changeChargeUserIdCard(file, fileList) {
      this.detailImageFileList = fileList;
    },

    removeChargeUserIdCard(file) {
      for (let item in this.detailImageFileList) {
        if (item && this.detailImageFileList[item] && file && this.detailImageFileList[item].uid == file.uid) {
          this.detailImageFileList.splice(item, 1);
        }
      }
    },

    detailImageShowDialog(e) {
      this.detailImageShowUrl = e.url;
      this.detailImageShow = true;
    },


    insertSubmit() {

      //TODO 非空判断
      if (!this.insertForm.name) {
        this.showMessage("请填写专家姓名", "error");
        return false;
      }

      if (!this.insertForm.year) {
        this.showMessage("请填写年限", "error");
        return false;
      }


      //数据组装
      let params = new FormData();
      if (this.insertForm.userId) {
        params.append("userId", this.insertForm.userId);
      }
      params.append("name", this.insertForm.name);
      params.append("year", this.insertForm.year);
      params.append("level", this.insertForm.level);
      params.append("skill", this.insertForm.skill);
      params.append("context", this.insertForm.context);
      if (this.mainImageFile) {
        params.append("mainImageMultipartFile", this.mainImageFile.raw);
      } else {
        this.showMessage("请上传头像", "error");
        return false;
      }

      if (this.qrcodeImageFile) {
        params.append("qrcodeImageMultipartFile", this.qrcodeImageFile.raw);
      }

      if (this.detailImageFileList && this.detailImageFileList.length > 0) {
        for (let i = 0; i < this.detailImageFileList.length; i++) {
          let temp = this.detailImageFileList[i].raw;
          params.append("detailImageMultipartFile[]", temp);
        }
      } else {
        this.showMessage("请上传详细照片", "error");
        return false;
      }

      let url = "/admin/web/expert/insertExpert";
      this.alexPost(url, params, res => {
        //状态200
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.showMessage(res.data.msg, "success");
              this.insertCancel();
              this.listMerchantExpert();
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      }, {
        headers: {
          "Content-Type": "multipart/form-data",
          "token": localStorage.getItem("token")
        }
      });
    },
    // 新增 end

    // 详情 begin
    detailShow(data) {
      this.detailInfo = data;
      this.detailDialog = true;
    },

    detailCancel() {
      this.detailDialog = false;
      this.detailInfo = null;
    },
    // 详情 end

    // 留言咨询 begin
    ExpertMessageShow(expert) {
      if(expert&&expert.id){
        let expertId = expert.id;

        listAllExpertMessageApi({
          "expertId":expertId
        }, res => {
          if (res.status == "200") {
            if (res.data && res.data.status && res.data.msg) {
              if ("1" == res.data.status) {
                this.expertMessageList = res.data.resultSetData;
                console.info(this.expertMessageList);
              } else {
                this.showMessage(res.data.msg, "error");
              }
            } else {
              this.showMessage("未知请求出错", "error");
            }
          } else {
            this.showMessage("未知请求出错！", "error");
          }
        });


      }
      this.expertMessageDialog = true;

    },
    // 留言咨询 end


    //删除 begin
    deleteExpert(item) {
      if (!item) {
        this.showMessage("请选择需要删除的专家", "warning");
        return false;
      }
      let params = {
        "id": item.id
      };
      deleteExpertApi(params, res => {
        //状态200
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.showMessage(res.data.msg, "success");
              this.listMerchantExpert();
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },
    //删除 end

    // 修改 begin

    updateShow(data) {
      this.updateDialog = true;
      this.updateForm = {
        id: data.id,
        userId: data.userId,
        name: data.name,
        year: data.year,
        level: data.level,
        skill: data.skill,
        context: data.context
      };


      this.updateMainImageFileUrl = "/admin/web/file/downloadFile?id=" + data.mainImageGuid;//缩略图返显 上传
      if (data.qrcodeImageGuid) {
        this.updateQrcodeImageFileUrl = "/admin/web/file/downloadFile?id=" + data.qrcodeImageGuid;//缩略图返显 上传
      }
      this.updateDetailImageFileListUrl = [];//详情页 图片数组
      if (data.detailImageGuid && data.detailImageGuid.length > 0) {
        for (let i = 0; i < data.detailImageGuid.length; i++) {
          let guid = data.detailImageGuid[i];
          this.updateDetailImageFileListUrl.push({
            name: guid,
            url: "/admin/web/file/downloadFile?id=" + guid
          });
        }
      }
    },


    updateCancel() {
      this.updateDialog = false;
      this.updateForm = {
        id: null,
        name: null,
        year: null,
        level: null,
        skill: null,
        context: null
      };
      this.updateMainImageFile = null;
      this.updateMainImageFileUrl = null; //返现

      this.updateQrcodeImageFile = null;
      this.updateQrcodeImageFileUrl = null; //返现

      this.updateDetailImageShow = false;
      this.updateDetailImageShowUrl = "";
      this.updateDetailImageFileListUrl = [];
    },


    // 营业执照上传
    updateChangeCompanyIdCard(file) {

      let thizz = this;

      thizz.updateMainImageFile = file;
      thizz.updateMainImageFileUrl = file.url;


    },

    // 营业执照上传
    updateChangeQrcodeCompanyIdCard(file) {
      this.updateQrcodeImageFile = file;
      this.updateQrcodeImageFileUrl = file.url;
    },

    //身份证上传
    updateChangeChargeUserIdCard(file, fileList) {
      this.updateDetailImageFileListUrl = fileList;
    },

    updateRemoveChargeUserIdCard(file) {
      for (let item in this.updateDetailImageFileListUrl) {
        if (item && this.updateDetailImageFileListUrl[item] && file && this.updateDetailImageFileListUrl[item].uid == file.uid) {
          this.updateDetailImageFileListUrl.splice(item, 1);
        }
      }
    },

    updateDetailImageShowDialog(e) {
      this.updateDetailImageShowUrl = e.url;
      this.updateDetailImageShow = true;
    },


    updateSubmit() {

      //TODO 非空判断
      if (!this.updateForm.name) {
        this.showMessage("请填写专家姓名", "error");
        return false;
      }

      if (!this.updateForm.year) {
        this.showMessage("请填写年限", "error");
        return false;
      }


      //数据组装
      let params = new FormData();
      params.append("id", this.updateForm.id);
      if (this.updateForm.userId) {
        params.append("userId", this.updateForm.userId);
      }
      params.append("name", this.updateForm.name);
      params.append("year", this.updateForm.year);
      params.append("level", this.updateForm.level);
      params.append("skill", this.updateForm.skill);
      params.append("context", this.updateForm.context);

      if (this.updateMainImageFile) {
        params.append("mainImageMultipartFile", this.updateMainImageFile.raw);
      }
      if (this.updateQrcodeImageFile) {
        params.append("qrcodeImageMultipartFile", this.updateQrcodeImageFile.raw);
      }
      if (this.updateDetailImageFileListUrl && this.updateDetailImageFileListUrl.length > 0) {
        for (let i = 0; i < this.updateDetailImageFileListUrl.length; i++) {
          let temp = this.updateDetailImageFileListUrl[i];
          if (temp) {
            if (temp.status == "success") {
              params.append("detailImageListFileGuid[]", temp.name);
            }
            if (temp.status == "ready") {
              params.append("detailImageMultipartFile[]", temp.raw);
            }
          }
        }
      }

      let url = "/admin/web/expert/updateExpert";
      this.alexPost(url, params, res => {
        //状态200
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.showMessage(res.data.msg, "success");
              this.updateCancel();
              this.listMerchantExpert();
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      }, {
        headers: {
          "Content-Type": "multipart/form-data",
          "token": localStorage.getItem("token")
        }
      });
    },

    // 修改 end

    // 工具
    parseDate(date) {
      if (date) {
        return new Date(date).toLocaleString();
      }
      return "";
    }
  }


}
;

</script>


<style scoped>

/deep/ .el-card__body, .el-main {
  float: left;
  width: 100%;
}

/*  通用 */
.dialog-footer {
  width: 100%;
  float: left;
  text-align: left;
}

.dialog-footer-submit {
  background-color: #25AD7F;
  color: white;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-submit:hover {
  background-color: #25AD7F;
  color: white;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-cancel {
  background-color: white;
  border: 1px solid #8080805c;
  color: #8080805c;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-cancel:hover {
  background-color: white;
  border: 1px solid #8080805c;
  color: #8080805c;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

/* 树形菜单 */

/deep/ .el-tree-node__content {
  height: 35px;
  line-height: 35px;
}

/* 表格 */

/deep/ .el-table th.el-table__cell {
  background-color: #F8F8F8;
}

/deep/ .el-table th.el-table__cell > .cell {
  color: #554 !important;
  font-weight: 600;
  font-size: 1.05rem;
}


/* 模态框 */

/deep/ .el-dialog__title {
  font-weight: 600;
}

/deep/ .el-dialog__header {
  text-align: left;
  border-bottom: 1px solid darkgray;
}

/deep/ .el-dialog__body {
  width: 100%;
  float: left;
  background-color: white;
}

/deep/ .el-upload-dragger {
  height: auto;
}

/deep/ .el-form-item__content {
  text-align: left;
}


/* 纯数字 */
/deep/ .numberInput input::-webkit-outer-spin-button,
/deep/ .numberInput input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ .numberInput input[type="number"] {
  -moz-appearance: textfield;
}


.text-ellipsis {
  white-space: nowrap;
  /* 确保文本在一行内显示 */
  overflow: hidden;
  /* 超出部分隐藏 */
  text-overflow: ellipsis;
  /* 使用省略号表示超出的文本 */
  width: 100%;
  /* 让div充满容器的宽度 */
}
</style>
